import { Pipe, PipeTransform } from '@angular/core';
import { PackagingModel } from '@hazmatsuite-next/easydgd-lib';

@Pipe({
  name: 'filterOverpack',
})
export class FilterOverpackPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: PackagingModel[], parentId?: string): any[] {
    if (parentId) {
      return value.filter(item => item.ParentId === parentId);
    }

    return value?.filter(item => !item.ParentId);
  }
}
